export { default as InputRfc } from './input-rfc';
